import { ChangeDetectorRef, Component, OnInit,Output, EventEmitter, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap';
import { DialogHelper, ExceptionHelper } from '../../../../helper';
import { CustomerSiteSummaryService, CustomerSummaryService } from '../../customer';
import { EquipmentSummaryService } from '../equipment-summary/equipment-summary.service';
import { IsActive} from '../../../../model';
@Component({
  selector: 'app-equipment-migrate',
  templateUrl: './equipment-migrate.component.html',
  styleUrls: ['./equipment-migrate.component.css']
})
export class EquipmentMigrateComponent implements OnInit {
  @ViewChild('successModal') successModal: any;

  form = this.fb.group({
    equipmentIds: [[], [Validators.required]],
    customerId: [''],
    siteId: ['', [Validators.required]],
  });


  dropdownSettingsCustomer = {};
  dropdownSettingsEquipment = {};
  dropdownSettings = {};
  customerId: FormControl;

  siteId: any;
  equipmentIds: Array<string> = [];
  redirect = true;
  selectedCustomerName = '';
  selectedCustomerShortName = '';
  selectedSiteName = '';

  selectedIds: number[];

  selectedEquipmentName = '';
  selectedEquipmentIds: number[];
  customers = [];
  sites = [];
  equipments = [];
  bsModalRef: BsModalRef;

  migratedEquipmentList = [];

  constructor(private router: Router, private route: ActivatedRoute, private fb: FormBuilder,
    private customerSummaryService: CustomerSummaryService,
    private customerSiteSummaryService: CustomerSiteSummaryService,
    private exception: ExceptionHelper,    
    private equipmentSummaryService: EquipmentSummaryService,
    private chRef: ChangeDetectorRef,
    private dialog: DialogHelper) { }

  ngOnInit() {
    

    this.getCustomerSummary()
    this.getEquipmentSummary()

    this.selectedIds = [];

    this.dropdownSettingsCustomer = {
      singleSelection: true,
      text: 'Select Customer',
      enableSearchFilter: true,
      labelKey: 'shortName',
      enableFilterSelectAll: false,
      showCheckbox: false
    };


    this.dropdownSettings = {
      singleSelection: true,
      text: 'Select Site',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'locationShort',
      showCheckbox: false
    };
 

    this.dropdownSettingsEquipment = {
      singleSelection: false,
      text: 'Select Equiqment',
      enableCheckAll: false,
      enableSearchFilter: true,
      labelKey: 'equipmentIdName',
      primaryKey: 'equipmentId'
    };
  }

  submit() {
    if (this.form.valid) {
      const equipmentIds = this.form.value['equipmentIds'].map(eq => eq.equipmentId)
      const siteId = this.form.value['siteId'].length != 0 ? this.form.value['siteId'][0].id : ""

      this.equipmentSummaryService.migrate(equipmentIds, siteId).subscribe((data: any) => {
        if (data) {
          this.migratedEquipmentList = data.equipmentListModel
          this.dialog.showModal('showSucModalBtn');
        }
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
      
    }
  }

  getEquipmentSummary() { 
    this.equipmentSummaryService.getSummary(null, null, IsActive.active)
      .subscribe((data: any) => {
        this.equipments = data.equipmentListModel;
        $('div.c-btn').attr('id', 'multi-select');
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      }, () => {
        this.chRef.detectChanges();
      });
  }
  getCustomerSummary(): void {
    this.customerSummaryService.getSummary(IsActive.active)
      .subscribe((data: any) => {
        this.customers = data.customerListModel;
        for (const customer of this.customers) {
          if (customer.id == this.customerId) {
            this.form.controls['customerId'].setValue([customer]);
            this.selectedCustomerName = customer.name;
            this.selectedCustomerShortName = customer.shortName;
            this.getSiteSummary(customer.id);
          }
        }
        $('div.c-btn').attr('id', 'single-select');
      }, error => {
          this.exception.showError(error, 'showDanModalBtn');
          this.redirect = true;
      }, () => {
        this.chRef.detectChanges();
      });
  }

  getSiteSummary(customerId): void {
    this.customerSiteSummaryService.getSummary(customerId, IsActive.active)
      .subscribe((data: any) => {
        this.sites = data.siteListModel;
      },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
          this.redirect = true;
        });
  }

  public onCloseSite(items: any) {
    
  }
  public onCloseEquipment(items: any) {
    if (this.form.value.equipmentIds.length === 0) {
      this.form.controls['equipmentIds'].setErrors({'required': true});
    }
  }


  onSiteSelect(item: any) {
    this.selectedSiteName = item.locationShort;
  }
  

  onEquipmentSelect(item: any) {

  }

  onCustomerSelect(item: any) {
    this.customerId = item.id;
    // clear site input
    this.form.controls['siteId'].setValue([]);
    // get customer site summary
    if (this.customerId) {
      this.getSiteSummary(this.customerId);
    }
    this.selectedCustomerName = item.name;
    this.selectedCustomerShortName = item.shortName;
  }

  onCustomerDeselect(item: any) {
    // clear site input
    this.form.controls['siteId'].setValue([]);
    // clear site options
    this.sites = [];
  }


  public onClose(items: any) {

  }

  public closeSuccessModel(): void {
    this.router.navigate(['/home/equipment']);
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-migrate/equipment-migrate.component.ts